// @ts-check
import React from 'react';

import useMediaListSearch from '@/src/shared/hooks/useMediaLibraryListSearch';
import Section from "@/src/shared/components/Section";
import Container from "@/src/shared/components/Container";
import request from '@/utils/axios';
import Whitepapers from "@/src/cms/components/CMSPage/Content/Whitepapers";
import { ContentPageContextProvider } from "@/src/cms/context/ContentPageContext";
import ContentBody from "@/src/cms/components/CMSPage/Content/ContentBody";
import ContentLayout from "@/src/cms/components/CMSPage/Content/ContentLayout";

/** 
 * @param {{
 *   pagedata: import("@/src/cms/components/types").CMSPage;
 *   sitepageid: number;
 * }} props 
 */
function ResearchPapers({ pagedata, sitepageid }) {
  let [loading, results] = useMediaListSearch({
    attachmentResourceGroups: [{ Value: 1 }],
  });
  results = results.map((r) => ({...r, Tags: parseTags(r.Tags)}))

  return (
    <ContentPageContextProvider
      pagedata={pagedata}
      sitepageid={sitepageid}
      bypassAuth
    >
      <ContentLayout>
        <Section bgColor="gray">
          <Container size="sm" style={{ marginBottom: '40px' }}>
            <ContentBody />
          </Container>
          <Container>
            <Whitepapers loading={loading} whitepapers={results}  />
          </Container>
        </Section>
      </ContentLayout>
    </ContentPageContextProvider>
  );
};

const parseTags = (tags) => (typeof tags === 'string' && tags.length) ? tags.split(',') : [];

export async function getStaticProps() {
  const response = await request({
    url: `cms/corepage`,
    params: { alias: 'researchpapers' },
  });
  return { 
    props: { 
      pagedata: response?.data,
      sitepageid: 72451,
    } 
  }
}

export default ResearchPapers;
